
import { ToastProgrammatic as toast } from "buefy";
import { db } from "../firebase";

export const HelpersMixin = {
    data() {
        return {
            tabletWidth: 1023,
            mobileWidth: 768,
            windowWidth: window.innerWidth,
            resizeTimeout: null
        }
    },
    computed: {
        isMobileView() {
            return this.windowWidth  <= this.mobileWidth
        },
        isDesktopView() {
            return this.windowWidth  > this.tabletWidth
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
      },
    methods: {
        handleResize() {
            // Simple debounce implementation
            clearTimeout(this.resizeTimeout)
            this.resizeTimeout = setTimeout(() => {
              this.windowWidth = window.innerWidth
            }, 100) // Adjust timing as needed (100ms is good for most cases)
          },
        cleanObject(obj) {
            if (Array.isArray(obj)) {
                return obj
                    .map(item => this.cleanObject(item))
                    .filter(item => item !== undefined && item !== null);
            } else if (obj !== null && typeof obj === 'object') {
                const cleaned = {};
                for (const [key, value] of Object.entries(obj)) {
                    const cleanedValue = this.cleanObject(value);
                    if (
                        cleanedValue !== undefined &&
                        cleanedValue !== null &&
                        !(typeof cleanedValue === 'number' && isNaN(cleanedValue))
                    ) {
                        cleaned[key] = cleanedValue;
                    }
                }
                return cleaned;
            } else {
                return (obj !== undefined && obj !== null && !(typeof obj === 'number' && isNaN(obj)))
                    ? obj
                    : undefined;
            }
        },
        copyToClipboard(textToCopy) {
            // Copy the text inside the text field
            navigator.clipboard.writeText(textToCopy);

            toast.open({
                duration: 10000,
                message:
                    "Text copied to clipboard.",
                position: "is-bottom",
            });
        },
        isVideo(url) {
            console.log(url);
            const videoExtensions = ["mp4", "webm", "ogg", "mov", "mkv"];
            const extension = url.split("?")[0].split(".").pop().toLowerCase();
            return videoExtensions.includes(extension);
        },
        getOverallRating(ratings) {
            if (ratings.length === 0) {
                return 0; // Return 0 if no ratings provided
            }

            // Calculate sum of ratings
            const sumOfRatings = ratings.reduce((total, rating) => total + rating, 0);

            // Calculate overall rating by dividing sum by number of ratings
            const overallRating = sumOfRatings / ratings.length;

            // Round to 2 decimal places
            return parseFloat(overallRating.toFixed(2));
        },
        isValidEmail(email) {
            // Regular expression for validating email addresses
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        slugify(url) {
            const decodedUrl = decodeURIComponent(url);
            const seoFriendlyUrl = decodedUrl.toLowerCase().replace(/\s+/g, '-').replace(/:/g, '');
            return seoFriendlyUrl;
        },
        subscribeToNewsletter(email) {
            db.firestore()
                .collection("newsletter")
                .add({ email })
                .then(() => {
                    this.$buefy.toast.open({
                        duration: 10000,
                        message: "Thank you for subscribing to our newsletter!",
                        position: "is-bottom",
                        type: "is-success",
                    });
                })
                .catch((error) => {
                    this.$buefy.toast.open({
                        duration: 10000,
                        message: error,
                        position: "is-bottom",
                        type: "is-danger",
                    });
                });
        }
    }
}